import { Component, OnInit, inject } from '@angular/core';
import { Context } from '../../models/admin-models';
import { AdminService } from '../admin.service';
import { saveAs } from '@progress/kendo-file-saver';
import { Platform } from '@angular/cdk/platform';
import { EnvironmentService } from '../../services/environment.service';

import { ToolbarComponent } from '../toolbar/toolbar.component';
import { FormlyComponent } from '../../conditional-form/formly.component';
import { NgxLoadingModule } from 'ngx-loading';
import { UtilityToolbarComponent } from '../../shared-components/utility-toolbar/utility-toolbar.component';

@Component({
  selector: 'app-unit-profile',
  templateUrl: './unit-profile.component.html',
  styleUrls: ['./unit-profile.component.scss'],
  imports: [
    ToolbarComponent,
    FormlyComponent,
    NgxLoadingModule,
    UtilityToolbarComponent,
  ],
})
export class UnitProfileComponent implements OnInit {
  private admnSrvc = inject(AdminService);
  private pltfrm = inject(Platform);
  private envSvc = inject(EnvironmentService);

  private environment;
  tabContext: Context = { type: 'unitProfile', unit: null, app: null };
  profileData;
  loading = false;
  save;
  private baseUrl: string;

  ngOnInit() {
    this.environment = this.envSvc.get();
    this.baseUrl = this.environment.apiBase;
  }

  getUnitProfile(ev) {
    this.loading = true;
    this.tabContext.unit = ev.unit;
    let profileApp = ev.app === 'shared' ? 'rb' : ev.app;
    switch (ev.app) {
      case 'tm':
        this.tabContext.app = 'dl';
        profileApp = 'dl';
        break;
      case 'am':
        this.tabContext.app = 'arl';
        profileApp = 'arl';
        break;
      case 'fpm':
        this.tabContext.app = 'fpml';
        profileApp = 'fpml';
        break;
      default:
        this.tabContext.app = ev.app;
        break;
    }
    this.admnSrvc.getUnitProfile(ev.unit, profileApp, ev.uiType).subscribe({
      next: data => {
        this.profileData = data.results.questionnaire;
        this.loading = false;
      },
      error: () => {
        console.error(
          'Network Error. This may mean an invalid Unit ID was entered.'
        );
        this.loading = false;
      },
    });
  }

  getUnitProfileReport(ev) {
    this.loading = true;
    const iosSafari =
      this.pltfrm.IOS ||
      (navigator?.['userAgentData']?.platform === 'macOS' &&
        navigator.maxTouchPoints > 1);

    this.admnSrvc
      .getUnitProfileReport(ev.unit, ev.app, ev.type)
      .subscribe(data => {
        const filename = `${ev.unit}_${ev.app}_${ev.type}_report.pdf`;

        let fileData;
        const reader = new FileReader();
        reader.readAsDataURL(data);
        reader.onloadend = () => {
          fileData = reader.result;
          saveAs(fileData, filename, {
            proxyURL: `${this.baseUrl}/util/proxy`,
            proxyTarget: '_self',
            forceProxy: iosSafari,
          });
        };
        this.loading = false;
      });
  }

  saveUnitProfile() {
    this.save = 'unitProfile';
  }
}
